import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=464ef6da&scoped=true&"
import script from "./change-password.vue?vue&type=script&lang=ts&"
export * from "./change-password.vue?vue&type=script&lang=ts&"
import style0 from "./change-password.vue?vue&type=style&index=0&id=464ef6da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464ef6da",
  null
  
)

export default component.exports